import * as React from 'react';
import { Flag } from "../../../components/Flag";

type Props = { children?: React.ReactNode }
export const NonIsolatedPremise:React.SFC<Readonly<Props>> = (props: Readonly<Props>) => (
    <Flag name="nonIsolatedPremise">
        {props.children}
    </Flag>
)


// WEBPACK FOOTER //
// ./src/app/components/NonIsolatedPremise/NonIsolatedPremise.tsx